import { Card, Grid, Icon, IconButton, Switch, Autocomplete } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { successAlert } from "utils/Functions";
import { get, postNoResponse } from "utils/WebService";
import { categoriaOcorrenciaEnum } from "utils/Enums";
import { useUser } from "context/UserContext";

export default function TipoOcorrenciaCreateEdit({ id, closeCreateEdit }) {
    const { userPerfils } = useUser();
    const isAdminOrSuporte = userPerfils && userPerfils.some(p => {
        const pName = (p?.nome || (typeof p === 'string' ? p : "")).toUpperCase();
        return p?.tipoPerfil === 4 || p?.tipoPerfil === 6 || pName === 'ADMINISTRADOR' || pName === 'SUPORTE';
    });

    const availableCategories = isAdminOrSuporte ? categoriaOcorrenciaEnum : categoriaOcorrenciaEnum.filter(c => c.code === 1);


    const [initialValues, setInitialValues] = useState({
        id: null,
        nome: "",
        cor: "success",
        categoria: 1,
        ativo: true,
        equipesIds: [],
        statusFichaIds: [],
        permiteAgendamento: false,
        prazoMaxAgendamento: 0
    });

    const [grupos, setGrupos] = useState([]);
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        get("/equipe/list-all").then((res) => {
            setGrupos(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        get("/status-ficha/list-all").then((res) => {
            setStatuses(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        if (id) {
            get(`/tipo-ocorrencia/by-id/${id}`).then((res) => {
                if (res) {
                    setInitialValues({
                        ...res,
                        categoria: res.categoria || 1,
                        equipesIds: res.equipesIds || [],
                        statusFichaIds: res.statusFichaIds || []
                    });
                }
            });
        }
    }, [id]);

    const handleSubmit = (values, { setSubmitting }) => {
        postNoResponse("/tipo-ocorrencia/save", values)
            .then(() => {
                successAlert("Tipo de Ocorrência salvo com sucesso!", () => closeCreateEdit());
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <Card id="tipo-ocorrencia-form">
            <MDBox display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1 }}>
                    <MDTypography variant="h5"><Icon>arrow_back</Icon></MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar Tipo de Ocorrência" : "Novo Tipo de Ocorrência"}</MDTypography>
            </MDBox>

            <MDBox component="section" px={3} pb={3}>
                <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
                    {({ values, handleChange, setFieldValue, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <MDInput fullWidth name="nome" label="Nome" variant="standard" value={values.nome || ""} onChange={handleChange} required />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        options={availableCategories}
                                        getOptionLabel={(option) => option.label}
                                        value={availableCategories.find(c => c.code === values.categoria) || availableCategories[0]}
                                        onChange={(event, newValue) => {
                                            const catCode = newValue ? newValue.code : 1;
                                            let newCor = "success";
                                            if (catCode === 2) newCor = "info";
                                            if (catCode === 3) newCor = "warning";
                                            if (catCode === 4) newCor = "error";
                                            if (catCode === 5) newCor = "secondary";
                                            setFieldValue("categoria", catCode);
                                            setFieldValue("cor", newCor);
                                        }}
                                        renderInput={(params) => <MDInput {...params} label="Categoria" variant="standard" required />}
                                        isOptionEqualToValue={(option, value) => option.code === value?.code}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        options={[
                                            { code: null, label: "Nenhuma (Sem alteração)" },
                                            { code: 1, label: "Devolvido" },
                                            { code: 2, label: "Cobrança" },
                                            { code: 3, label: "Negociação" },
                                            { code: 4, label: "Pesquisa" },
                                            { code: 5, label: "Suspenso" },
                                            { code: 6, label: "Migrado" },
                                            { code: 7, label: "Quitado" }
                                        ]}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={[
                                            { code: null, label: "Nenhuma (Sem alteração)" },
                                            { code: 1, label: "Devolvido" },
                                            { code: 2, label: "Cobrança" },
                                            { code: 3, label: "Negociação" },
                                            { code: 4, label: "Pesquisa" },
                                            { code: 5, label: "Suspenso" },
                                            { code: 6, label: "Migrado" },
                                            { code: 7, label: "Quitado" }
                                        ].find(s => s.code === values.situacaoFicha) || { code: null, label: "Nenhuma (Sem alteração)" }}
                                        onChange={(event, newValue) => {
                                            setFieldValue("situacaoFicha", newValue ? newValue.code : null);
                                        }}
                                        renderInput={(params) => <MDInput {...params} label="Altera Situação da Ficha para" variant="standard" />}
                                        isOptionEqualToValue={(option, value) => option.code === value?.code}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} display="flex" alignItems="center" pt={4} pl={2}>
                                    <MDTypography variant="button" fontWeight="regular" color="text">Inativo</MDTypography>
                                    <Switch checked={values.ativo} onChange={(e) => setFieldValue("ativo", e.target.checked)} />
                                    <MDTypography variant="button" fontWeight="regular" color="text">Ativo</MDTypography>
                                </Grid>
                                <Grid item xs={12} sm={4} display="flex" alignItems="center" pt={4} pl={2}>
                                    <Switch checked={values.permiteAgendamento} onChange={(e) => setFieldValue("permiteAgendamento", e.target.checked)} />
                                    <MDTypography variant="button" fontWeight="regular" color="text">Permite Agendamento?</MDTypography>
                                </Grid>
                                {values.permiteAgendamento && (
                                    <Grid item xs={12} sm={4}>
                                        <MDInput fullWidth type="number" name="prazoMaxAgendamento" label="Prazo Máx. (Dias Úteis)" variant="standard" value={values.prazoMaxAgendamento || 0} onChange={handleChange} required />
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={12}>
                                    <Autocomplete
                                        multiple
                                        options={grupos}
                                        getOptionLabel={(option) => option.nome || option.ccNome || option.id}
                                        value={grupos.filter(g => (values.equipesIds || []).includes(g.id))}
                                        onChange={(event, newValue) => {
                                            setFieldValue("equipesIds", newValue.map(v => v.id));
                                        }}
                                        renderInput={(params) => <MDInput {...params} label="Grupos com Acesso (Deixe vazio para Todos/Apenas Admins)" variant="standard" placeholder="Selecione..." />}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Autocomplete
                                        multiple
                                        options={statuses}
                                        getOptionLabel={(option) => option.ccNome || option.nome || option.id}
                                        value={statuses.filter(s => (values.statusFichaIds || []).includes(s.id))}
                                        onChange={(event, newValue) => {
                                            setFieldValue("statusFichaIds", newValue.map(v => v.id));
                                        }}
                                        renderInput={(params) => <MDInput {...params} label="Status Vinculados (Deixe vazio para Todos)" variant="standard" placeholder="Selecione..." />}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    />
                                </Grid>
                            </Grid>

                            <MDBox display="flex" justifyContent="flex-end" mt={4}>
                                <MDButton variant="outlined" color="secondary" onClick={closeCreateEdit} sx={{ mr: 2 }}>Cancelar</MDButton>
                                <MDButton variant="contained" color="info" type="submit" disabled={isSubmitting}>Salvar</MDButton>
                            </MDBox>
                        </Form>
                    )}
                </Formik>
            </MDBox>
        </Card>
    );
}
